import React, { useContext, useState } from 'react';

import InnerTabs from '../../common_components/InnerTabs';
import Layout from '../../common_components/Layout';
import { PlotAdjustForm, ExportForm } from '../components/Forms';
import { SvgPlot } from '../../common_components/SvgPlot';
import { AppContext } from '../contexts';

export default function Tendencies({ data, name }) {
  const initialVisualization = 'timeseries';
  const app = useContext(AppContext);

  const [isLoading, setIsLoading] = useState(true);
  const [selectedVisualization, setSelectedVisualization] =
    useState(initialVisualization);
  const [visualizationData, setVisualizationData] = useState({
    trend: null,
    timseries: null,
  });

  const formSubmitRequest = (formData) =>
    app.APIs.steps.visualization(
      app.activeProject.id,
      name,
      selectedVisualization,
      app.activeProject.filehash,
      formData,
    );
  const onFormSubmitSuccess = (data) => {
    setVisualizationData((p) => ({
      ...p,
      [selectedVisualization]: data,
    }));
  };

  return (
    <Layout
      title="Tendencje"
      sideContent={
        <>
          <PlotAdjustForm
            fieldsData={data?.['form_data']?.[`${selectedVisualization}`]}
            formSubmitRequest={formSubmitRequest}
            onSubmitSuccess={onFormSubmitSuccess}
            isLoading={isLoading}
            setPlotIsLoading={setIsLoading}
            autoSubmit
          />
          <ExportForm
            svgBlob={visualizationData[selectedVisualization]}
            isLoading={isLoading}
          />
        </>
      }
      mainContent={
        <>
          <InnerTabs
            tabs={[
              {
                label: 'Seria czasu',
                content: visualizationData['timeseries'] && (
                  <SvgPlot imgBlob={visualizationData['timeseries']}></SvgPlot>
                ),
                onClick: () => setSelectedVisualization('timeseries'),
                defaultChecked: initialVisualization == 'timeseries',
              },
              {
                label: 'Trend',
                content: visualizationData['trend'] && (
                  <SvgPlot imgBlob={visualizationData['trend']}></SvgPlot>
                ),
                onClick: () => setSelectedVisualization('trend'),
                defaultChecked: initialVisualization == 'trend',
              },
            ]}
            isLoading={isLoading}
          ></InnerTabs>
        </>
      }
    ></Layout>
  );
}
